import Vue from "vue";

Vue.use({
  install() {
    Vue.prototype.$suspended = function(slug) {
      this.$store.dispatch("local/set", { key: "suspended", value: true });
      this.$store.dispatch("local/set", { key: "redirect-route", value: slug });
    };
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/suspended.js